import React, { Component } from 'react'
import propTypes from 'prop-types'

import styles from './styles.scss'

/** Components */
import { PopOver } from '../commons/PopOver'
import IconComponent from '../commons/IconComponent'


class Select extends Component {
  state = {
    showOptions: false
  }

  render () {
    const { showOptions } = this.state
    const { icon, label, children } = this.props

    return (
      <div 
        className={styles['wrapper-select-filter']}
        onClick={() => this.setState( { showOptions: !showOptions } )}
        aria-hidden={true}
      >
        <span>
          { icon && <IconComponent icon={icon} /> }
          { label }
        </span>

        {showOptions && (
          <PopOver hidePopover={() => this.setState( { showOptions: false } )}>
            <ul>
              { children }
            </ul>
          </PopOver>
        )}
        <IconComponent icon="caret-down" className='data-selects-icon' />
      </div>
    )
  }
}

Select.propTypes = {
  label: propTypes.string,
  icon: propTypes.string
}

Select.defaultProps = {
  label: 'Filter',
  icon: ''
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js